import LeadingScrollLock from "./_leading-scroll-lock";
import Utilities from "../_utilities";
import Backhead from "../_backhead";
import LeadingModal from "./_leading-modal";
import ScrollHint from "./_scroll-hint";
import SolutionFilter from "./_leading-solution-filter";
const leadingScrollLock = new LeadingScrollLock();
const backhead = new Backhead();
const modal = new LeadingModal;
const hint = new ScrollHint;
const solutionFilter = new SolutionFilter;
const layer = document.querySelector('.leading-layer');
const backBtn = document.querySelector('.leading-header__back');
//
// ロード時レイヤー
window.addEventListener('load', () => {
    layer.classList.add('fadeout');
    setTimeout(() => {
        layer.remove();
    }, 1200);
});
// backボタン
backBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    window.history.back();
});
// iOSのbackground-attachementバグ対策
if (Utilities.deviceInspector().isIOS || Utilities.deviceInspector().isIPadOS) {
    document.querySelector('html').classList.add('is-iOS');
}
